import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';

import {
  TextInput,
  SelectInput
} from 'components/Common/Inputs';
import RadioTableGroup from 'components/Common/Inputs/RadioTableGroup';
import Introduction from 'components/Questionnaire/Introduction';
import TINQuestions from 'components/Questionnaire/TINQuestions';

class QuestionnaireForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isSubmittingAnswers: PropTypes.bool,
    questionSet: PropTypes.arrayOf(PropTypes.shape({
      question: PropTypes.string,
      fieldName: PropTypes.string,
      fieldType: PropTypes.string.isRequired,
    })).isRequired,
    taxResidency: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    isSubmittingAnswers: false,
    taxResidency: null
  };

  constructor(props) {
    super(props);
    this.state = {
      currentQuestion: 0
    };
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { dispatch, taxResidency } = this.props;

    if (taxResidency === nextProps.taxResidency) {
      return;
    }

    if (nextProps.taxResidency && nextProps.taxResidency.length > 0) {
      for (let i = 0; i < 3; i += 1) {
        if (nextProps.taxResidency[i]) {
          dispatch(change('questionnaire-form', `accountHolderTaxInfo[${ i }].countryOfTaxResidence`, nextProps.taxResidency[i]));
        } else {
          dispatch(change('questionnaire-form', `accountHolderTaxInfo[${ i }].countryOfTaxResidence`, ''));
        }
      }
    }
  }

  totalQuestions() {
    const { questionSet } = this.props;
    return questionSet ? questionSet.length : 0;
  }

  nextQuestionClick() {
    const { currentQuestion } = this.state;

    if (currentQuestion !== this.totalQuestions()) {
      this.setState({ currentQuestion: currentQuestion + 1 });
    }
  }

  previousQuestionClick() {
    const { currentQuestion } = this.state;

    if (currentQuestion !== 1) {
      this.setState({ currentQuestion: currentQuestion - 1 });
    }
  }

  render() {
    const { title, isSubmittingAnswers, questionSet, handleSubmit } = this.props;
    const { currentQuestion } = this.state;
    return (
      <form onSubmit={ handleSubmit }>
        <div className="header">
          <h1>{ title }</h1>
        </div>
        <div className="content">
          { /* eslint-disable react/no-array-index-key */ }
          { currentQuestion === 0 && <Introduction /> }
          { questionSet != null && questionSet.map((question, index) => {
            if (question != null) {
              switch (question.fieldType.toLowerCase()) {
                case 'yesno':
                  if (currentQuestion === index + 1) {
                    return (<div className="form-group" key={ index }>
                      <h2>{ question.question }</h2>
                      <RadioTableGroup
                        name={ question.fieldName }
                        items={ [
                          [
                            { text: 'Yes', value: true },
                            { text: 'No', value: false }
                          ]
                        ] }
                      />
                    </div>);
                  }
                  break;
                case 'text':
                  if (currentQuestion === index + 1) {
                    return (<div className="form-group" key={ index }>
                      <h2>{ question.question }</h2>
                      <Field
                        id={ question.fieldName }
                        name={ question.fieldName }
                        component={ TextInput }
                        className="form-input"
                      />
                    </div>);
                  }
                  break;
                case 'select':
                  if (currentQuestion === index + 1) {
                    return (<div className="form-group" key={ index }>
                      <h2>{ question.question }</h2>
                      <Field
                        id={ question.fieldName }
                        name={ question.fieldName }
                        component={ SelectInput }
                        className="form-select"
                      >
                        { question != null && question.options != null && question.options.map((option, oIndex) => option != null && <option key={ oIndex }>{ option }</option>) }
                      </Field>
                    </div>);
                  }
                  break;
                case 'select-multiple':
                  if (currentQuestion === index + 1) {
                    return (<div className="form-group" key={ index }>
                      <h2>{ question.question }</h2>
                      <Field
                        id={ question.fieldName }
                        name={ question.fieldName }
                        component={ SelectInput }
                        className="form-select"
                        type="select-multiple"
                        multiple
                        size={ question.lines }
                      >
                        { question != null && question.options != null && question.options.map((option, oIndex) => option != null && <option key={ oIndex }>{ option }</option>) }
                      </Field>
                    </div>);
                  }
                  break;
                case 'tin':
                  if (currentQuestion === index + 1) {
                    return (<div className="form-group" key={ index }>
                      <TINQuestions />
                    </div>);
                  }
                  break;
                default:
                  break;
              }
              return '';
            }
            return null;
          }) }
          { /* eslint-enable react/no-array-index-key */ }
        </div>
        <div className="footer">
          <div className="form-group submit-group">
            <div className="left-side">
              <button type="button" className="btn">Help</button>
            </div>
            <div className="right-side">
              <button type="button" className="btn" onClick={ e => this.previousQuestionClick(e) } disabled={ currentQuestion <= 1 }>
                Previous
              </button>
              <button type="button" className="btn" onClick={ e => this.nextQuestionClick(e) } disabled={ currentQuestion === this.totalQuestions() }>
                Next
              </button>
              <button type="submit" className="btn" disabled={ currentQuestion !== this.totalQuestions() }>
                { isSubmittingAnswers && <span className="icon loading" /> } Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const BlankQuestionnaireReduxForm = reduxForm({
  form: 'questionnaire-form'
})(QuestionnaireForm);

const selector = formValueSelector('questionnaire-form'); // <-- same as form name

export const BlankQuestionnaire = connect((state) => {
  // can select values individually
  const taxResidency = selector(state, 'taxResidency');
  return {
    taxResidency
  };
})(BlankQuestionnaireReduxForm);

export default BlankQuestionnaire;
